import { LoadingLine } from '@jetshop/ui/Loading/LoadingLine';
import React from 'react';
import { styled } from 'linaria/react';
import { css } from 'linaria';
import { PagePadding } from '../Layout/MaxWidth';
import { BlogArticleMaxWidth } from './BlogArticle';

const backgroundColor = '#EEE';

const MockImage = styled('div')`
  padding-top: 50%;
  width: 100%;
  background: ${backgroundColor};
`;

export default React.memo(function BlogArticleLoadingState() {
  return (
    <PagePadding>
      <BlogArticleMaxWidth>
        <LoadingLine
          color={backgroundColor}
          widthRem={20}
          heightPx={10}
          className={css`
            margin: 1rem 0 2rem;
          `}
        />
        <MockImage />
        <LoadingLine
          color={backgroundColor}
          widthRem={40}
          heightPx={50}
          className={css`
            margin: 3rem auto 2rem;
          `}
        />
        <LoadingLine
          color={backgroundColor}
          widthRem={10}
          heightPx={5}
          className={css`
            width: 100%;
            margin: 15px 0;
          `}
        />
        <LoadingLine
          color={backgroundColor}
          widthRem={10}
          heightPx={5}
          className={css`
            width: 100%;
            margin: 15px 0;
          `}
        />
        <LoadingLine
          color={backgroundColor}
          widthRem={10}
          heightPx={5}
          className={css`
            width: 90%;
            margin: 15px 0;
          `}
        />
        <LoadingLine
          color={backgroundColor}
          widthRem={10}
          heightPx={5}
          className={css`
            width: 95%;
            margin: 15px 0;
          `}
        />
        <LoadingLine
          color={backgroundColor}
          widthRem={10}
          heightPx={5}
          className={css`
            width: 80%;
            margin: 15px 0;
          `}
        />
        <LoadingLine
          color={backgroundColor}
          widthRem={10}
          heightPx={5}
          className={css`
            width: 100%;
            margin: 15px 0;
          `}
        />
        <LoadingLine
          color={backgroundColor}
          widthRem={10}
          heightPx={5}
          className={css`
            width: 95%;
            margin: 15px 0;
          `}
        />
        <LoadingLine
          color={backgroundColor}
          widthRem={10}
          heightPx={5}
          className={css`
            width: 100%;
            margin: 15px 0 15rem;
          `}
        />
      </BlogArticleMaxWidth>
    </PagePadding>
  );
});
